import { useMemo } from 'react';

export function useRouteParams() {
  return useMemo(() => {
    const pathname = window.location.pathname;
    const parts = pathname.split('/');

    // Find storyId - it's always after "story"
    const storyIndex = parts.indexOf('story');
    const storyId = storyIndex !== -1 ? parts[storyIndex + 1] : '';

    // Find entitySubdomain - it's at index 2 (after /stories/)
    const entitySubdomain = parts[2] || '';

    // Find publicationId - it's after "publications" if present
    const publicationsIndex = parts.indexOf('publications');
    const publicationId = publicationsIndex !== -1 ? parts[publicationsIndex + 1] : undefined;

    return {
      storyId,
      entitySubdomain,
      publicationId
    };
  }, []);
}
